import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getCarModel } from './carThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearCarKey } from '../../sell/sellKeys';
const SLICE_NAME = 'model';

export const modelSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearCarModel(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getCarModel });
        builder.addCase(clearCarKey, () => commonInitialState);
    },
});

export const { clearCarModel } = modelSlice.actions;

export const model = modelSlice.reducer;
